<div class="custom-snackbar-container">
  <jf-icon *ngIf="data.icon"
           [name]="data.icon"
           [size]="data.iconSize || 24"
           [strokeWidth]="data.iconStrokeWidth || 1">
  </jf-icon>
  <span class="snackbar-message">{{ data.message }}</span>
</div>
